var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ADPKD",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.0-Prognostic-Tools-Option-1",
    transform: "translate(-262.000000, -461.000000)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(274.398985, 471.958158) rotate(45.000000) translate(-274.398985, -471.958158) translate(266.898985, 458.958158)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.5,
    cy: 17.9914202,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,9.95570592 L7.5,1.38427734",
    id: "Line-3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    points: "3.37751116 4.12248884 7.5 0 11.6224888 4.12248884"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMale);
export default __webpack_public_path__ + "static/media/icon-male.4735d00ae6513a7bbff79414d97b0a1d.svg";
export { ForwardRef as ReactComponent };